const chat = {
  composer: {
    inputAriaLabel: 'Message input',
    placeholder: 'Ask about safety trends, drivers, incidents... type \'help\' for guidance.',
    sendMessage: 'Send message',
  },
  copyMarkdown: {
    action: 'Copy Markdown',
    copied: 'Copied!',
    title: 'Copy raw markdown to clipboard',
  },
  citations: {
    summary_one: 'Data source ({{count}})',
    summary_other: 'Data sources ({{count}})',
  },
  errors: {
    authenticationFailed: 'Authentication failed. Please sign in again.',
    authenticationHint: 'Make sure your login credentials are correct and try again.',
    dismiss: 'Dismiss error',
    loginRequired: 'Please sign in to send messages.',
    messageWithHint: '{{message}}\n\n**Hint:** {{hint}}',
    networkFailed: 'Network connection failed. Please check your internet connection and try again.',
    networkHint: 'Check that you have a stable internet connection and the SpeedGauge server is accessible.',
    requestFailed: 'Unable to send your message. Please try again.',
    serverHint: 'The server may be temporarily unavailable. Try again in a few moments.',
    sessionCreating: 'Your session is being created. Please wait a moment and try again.',
    sessionExpired: 'Your session expired due to inactivity. Please sign in again to continue.',
    sessionExpiredHint: 'Your session timed out after 24 hours of inactivity. This is normal for security purposes.',
  },
  feedback: {
    cancel: 'Cancel',
    characterCount: '{{count}} / {{maximum}}',
    close: 'Close feedback modal',
    commentTooLong_one: 'Comments must be {{formattedMaximum}} characters or less. Please remove {{formattedCount}} character.',
    commentTooLong_other: 'Comments must be {{formattedMaximum}} characters or less. Please remove {{formattedCount}} characters.',
    commentsLabel: 'Additional comments (optional)',
    commentsPlaceholder: 'Please share any specific feedback to help us improve...',
    helpful: 'Helpful',
    helpfulAriaLabel: 'Thumbs up - helpful',
    helpfulTitle: 'This response was helpful',
    notHelpful: 'Not helpful',
    notHelpfulAriaLabel: 'Thumbs down - Not helpful',
    notHelpfulTitle: 'This response was not helpful',
    remainingCharacters_one: '{{count}} character remaining',
    remainingCharacters_other: '{{count}} characters remaining',
    ratingQuestion: 'How would you rate this response?',
    reduceToSubmit: 'Please reduce comment length to submit',
    submit: 'Submit feedback',
    submitFailed: 'Unable to submit feedback. Please try again.',
    submitting: 'Submitting...',
    title: 'Message feedback',
  },
  history: {
    cancelDelete: 'Cancel',
    close: 'Close',
    closeTitle: 'Close session',
    confirmDelete: 'Confirm',
    confirmDeleteTitle: 'Confirm delete',
    delete: 'Delete session',
    deleteFailed: 'Unable to delete this session. Please try again.',
    deleteTitle: 'Delete session',
    empty: 'No chat history yet',
    invalidDate: 'Invalid date',
    invalidTime: 'Invalid time',
    loading: 'Loading...',
    loadingChat: 'Loading chat',
    showMore: 'Show more',
  },
  messageList: {
    ariaLabel: 'Chat messages',
  },
  map: {
    loading: 'Loading map...',
  },
  messages: {
    ariaLabel: '{{role}} message',
    assistant: 'Assistant',
    user: 'User',
    you: 'You',
  },
  status: {
    initializing: 'Initializing...',
    initializingAriaLabel: 'Initializing chat',
    thinking: 'Thinking...',
    thinkingAriaLabel: 'Assistant is thinking',
  },
  suggestions: {
    ariaLabel: 'Coach suggestions',
    generatedAriaLabel: 'Generated follow-up suggestions',
    empty: 'No Coach suggestions are available yet.',
    loading: 'Loading Coach suggestions...',
    rightPanel: 'Try asking Coach',
    send: 'Send {{title}}',
    unavailable: 'Coach suggestions are temporarily unavailable.',
  },
  streamEvents: {
    complete: 'Complete',
    event: 'Event',
    latest: 'Latest event: {{label}}',
    reasoning: 'Reasoning',
    response: 'Response started',
    sessionDocument: 'Session document',
    streamingResponse: 'Streaming response',
    toolUse: 'Using a tool',
    toolUseWithName: 'Tool use: {{name}}',
    toolResult: 'Tool result',
    toolResultWithName: 'Tool result: {{name}}',
    update: 'Updating',
  },
  welcome: {
    newUser: 'Hi! I am SpeedGauge Coach AI.\n\nHow can I assist you?',
    returning: {
      driverData: 'Welcome back! Ready to dive into your driver data?',
      explore: 'Nice to have you back! What would you like to explore?',
      goodToSeeYou: 'Good to see you! How can I help?',
      helloAgain: 'Hello again! How can I assist you?',
      insights: 'Welcome back! What insights can I help you discover?',
      readyToHelp: 'Hi there! What can I do for you today?',
      welcome: 'Welcome! What would you like to know?',
      welcomeBack: 'Welcome back! What can I help you with today?',
    },
  },
} as const;

export default chat;